<template>
  <div ref="control" :class="['control', { error: error.length }, { success: valid }]">
    <div class="control-wrap">
      <input
        v-model="val"
        :checked="val"
        :value="val"
        class="control-checkbox"
        ref="input"
        :id="id"
        :name="name"
        type="checkbox"
        @change="change"
        :placeholder="label"
        :v-validate="validate"
      />
      <a :href="link" v-if="link" target="_blank" :title="linkTitle" class="text-align">
        <span class="link">{{ label }}</span>
        <font-awesome-icon class="control-icon margin-left" icon="info-circle" />
      </a>

      <span class="text-align cursor-pointer" v-else>
        <span class="link">{{ label }}</span>
      </span>
    </div>

    <p class="control-error" v-if="hasError">{{ error[0] }}</p>
  </div>
</template>

<script>
export default {
  name: 'FormControlCheckbox',
  data() {
    return {
      val: null
    };
  },
  $_veeValidate: {
    value() {
      return this.val;
    },
    name() {
      return this.name;
    }
  },
  props: ['label', 'id', 'link', 'error', 'valid', 'name', 'validate', 'value', 'linkTitle'],
  mounted() {
    this.$refs.input.checked = this.value;
  },
  methods: {
    change() {
      this.$emit('input', this.$refs.input.checked);
    }
  },
  watch: {
    value(newVal) {
      this.$refs.input.checked = newVal;
      this.val = newVal;
      this.$parent.$validator.validate(this.name);
    }
  },
  computed: {
    hasError() {
      return !!this.error?.length;
    }
  }
};
</script>

<style lang="scss">
.text-align {
  display: inline-block;
  vertical-align: middle;
  text-align: left;
  text-decoration: none;
  color: var(--color-positive-normal);

  .control-icon {
    position: relative;
    transform: none;
    top: 0;
  }
}

a {
  text-decoration: underline;
}

.link {
  font-weight: 600;
}

.margin-left {
  margin-left: 5px;
}

.control-checkbox {
  min-width: 20px;
  max-width: 20px;
  min-height: 20px;
  max-height: 20px;
  margin-right: 8px;
  border-radius: 4px;
  background-color: var(--color-gray-white);
  border: 2px solid var(--color-gray-light);
  cursor: pointer;
  transition: var(--transition-input);

  &:hover {
    border-color: var(--color-gray-medium);
  }

  &:focus {
    border-color: var(--color-balanced);
    box-shadow: 0 0 0 3px rgba(var(--color-balanced-rgb), 0.2);
  }

  &:checked {
    position: relative;
    border-color: var(--color-balanced);
    background-color: rgba(var(--color-balanced-rgb), 0.1);

    &:before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 10px;
      height: 10px;
      border-radius: 2px;
      background-color: var(--color-balanced);
    }
  }
}
</style>
